import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_SPECIAL_CONSIDERATION_CHECK_ELIGIBILITY_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ErrorMessage {
  message: string;
  code: string;
}

export interface SpecialConsiderationEligibilityResponse {
  eligible: boolean;
  error: ErrorMessage;
}

export interface ExamLevelSeriesRequest {
  examLevelUuid: string;
  examSeriesUuid: string;
  groupScType?: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: SpecialConsiderationEligibilityResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCheckEligibility = ({ onSuccess, onError }: Input = {}) => {
  const postCheckEligibility = async (reqBody: ExamLevelSeriesRequest) => {
    const res = await axiosClient.post<SpecialConsiderationEligibilityResponse>(
      POST_SPECIAL_CONSIDERATION_CHECK_ELIGIBILITY_URL,
      reqBody
    );
    return res.data;
  };

  return useCustomMutation(postCheckEligibility, {
    onSuccess,
    onError,
  });
};
